import React, { useState, useRef } from "react";
import { Button, Card, Drawer, message } from "antd";
import { UserOutlined, PhoneOutlined, WalletOutlined, EditOutlined } from "@ant-design/icons";
import Close from "../../../../../assets/images/close-x.svg";
import useCartStore from "../../../../../stores/useCartStore";
import useTransactionStore from "../../../../../stores/useTransactionStore";
import useAuthStore from "../../../../../stores/useAuthStore";

const RefundWalletDrawer = ({
  isRefundWalletOpen,
  setIsRefundWalletOpen,
  selectedReturnType,
  selectedPaymentMethod,
  cart,
  currenciesList,
  requestPayment,
  processOrder,
  setDisplayCustomerSearch,
  pendingRefundCustomer,
}) => {
  const [submitting, setSubmitting] = useState(false);
  // Ref is the real guard; the state only drives the button UI. setSubmitting
  // does not update the captured closure synchronously, so two same-tick
  // invocations would both issue the refund.
  const submittingRef = useRef(false);
  const refundCustomer = useTransactionStore.getState().refundReturnCustomerId;
  const transactionStoreData = JSON.parse(localStorage.getItem("transactionStore") || "{}");
  const persistedReturnType = transactionStoreData?.state?.selectedReturnType;
  return (
    <Drawer
      placement="right"
      width="62%"
      closable={false}
      footer={null}
      styles={{ header: { background: "white", padding: "22px 3vh 10px 16px", borderBottom: "none" } }}
      styles={{
        body: {
          padding: "16px",
          background: "#ffffff",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
      }}
      open={isRefundWalletOpen || (persistedReturnType === "STORE_CREDIT" && cart?.items?.length > 0)}
      maskClosable={selectedReturnType !== "STORE_CREDIT" && persistedReturnType === "STORE_CREDIT" && cart?.items?.length > 0}
      onClose={() => {
        if (selectedReturnType !== "STORE_CREDIT" || (persistedReturnType === "STORE_CREDIT" && cart?.items?.length > 0)) setIsRefundWalletOpen(false);
      }}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 600,
              color: "#253856",
            }}
          >
            Refund to Customer Wallet
          </span>

          {selectedReturnType !== "STORE_CREDIT" && persistedReturnType === "STORE_CREDIT" && cart?.items?.length > 0 && (
            <img
              src={Close}
              onClick={() => setIsRefundWalletOpen(false)}
              style={{
                cursor: "pointer",
                width: 16,
                height: 16,
              }}
            />
          )}
        </div>
      }
    >
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingRight: 4,
        }}
      >
        <Card
          bordered
          style={{
            borderRadius: 8,
            marginBottom: 16,
          }}
          styles={{ body: { padding: 16 } }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 12,
            }}
          >
            <span style={{ fontWeight: 600, fontSize: "16px" }}>Customer</span>
            <EditOutlined
              style={{ color: "#253856", cursor: "pointer" }}
              onClick={() => {
                useTransactionStore.getState().setRefundCustomerEdit("Y");
                if (selectedReturnType !== "STORE_CREDIT") {
                  setIsRefundWalletOpen(false);
                }
                setTimeout(() => {
                  setDisplayCustomerSearch(true);
                }, 200);
              }}
            />
          </div>

          <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
            <UserOutlined />
            <span style={{ fontWeight: 500 }}>{refundCustomer?.name || cart?.customer?.name || ""}</span>
          </div>

          <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
            <PhoneOutlined />
            <span>{refundCustomer?.mobileNo || cart?.customer?.mobileNo}</span>
          </div>

          <div style={{ display: "flex", gap: 8, marginBottom: 6, alignItems: "center" }}>
            <WalletOutlined />
            <span style={{ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap" }}>
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              {Number(refundCustomer?.cwrWallet?.balance_Amt ?? cart?.customer?.cwrWallet?.balance_Amt ?? 0).toFixed(2)}
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            </span>
          </div>
        </Card>

        <Card
          bordered
          style={{
            borderRadius: 8,
            marginBottom: 16,
          }}
          styles={{ body: { padding: 16 } }}
        >
          <p style={{ fontWeight: 600, marginBottom: 16, fontSize: "16px" }}>Refund Summary</p>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
            <span>Return Amount</span>
            <span style={{ color: "#253856", fontWeight: 600 }}>
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              {Math.abs(cart?.total || 0).toFixed(2)}
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
            <span>Current Wallet Balance</span>
            <span>
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              {Number(refundCustomer ? refundCustomer?.cwrWallet?.balance_Amt : cart?.customer?.cwrWallet?.balance_Amt ? cart?.customer?.cwrWallet?.balance_Amt : 0).toFixed(2)}
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            </span>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
            <span>New Wallet Balance</span>
            <span>
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
              {(Math.abs(Number(cart?.total || 0)) + Number(refundCustomer?.cwrWallet?.balance_Amt ?? cart?.customer?.cwrWallet?.balance_Amt ?? 0)).toFixed(2)}
              {currenciesList && currenciesList.length > 0 && currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
            </span>
          </div>
        </Card>
      </div>
      <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
        <Button
          style={{ flex: 1, height: 40, borderRadius: 6 }}
          disabled={selectedReturnType === "STORE_CREDIT" || (persistedReturnType === "STORE_CREDIT" && cart?.items?.length > 0)}
          onClick={() => {
            setIsRefundWalletOpen(false);
            useTransactionStore.setState({
              refundCustomerEdit: null,
            });
          }}
        >
          Cancel
        </Button>

        <Button
          type="primary"
          disabled={submitting}
          loading={submitting}
          style={{
            flex: 1,
            height: 40,
            borderRadius: 6,
            background: "#253856",
            borderColor: "#16a34a",
          }}
          onClick={async () => {
            if (submittingRef.current || submitting) return;
            submittingRef.current = true;
            setSubmitting(true);
            try {
            const refundAmount = Math.abs(cart.total);
            const isStoreCredit = selectedReturnType === "STORE_CREDIT" || persistedReturnType === "STORE_CREDIT";

            // BUG-1193: For STORE_CREDIT wallet refunds, auto-resolve the wallet payment method
            // instead of blocking with "Select payment method" validation.
            let paymentMethodToUse = selectedPaymentMethod;
            if (!paymentMethodToUse?.name && isStoreCredit) {
              const tillData = useAuthStore.getState().tillData;
              const walletPM = tillData?.tillAccess?.csBunit?.paymentMethodList?.find((pm) => pm.isWallet === "Y");
              if (walletPM) {
                paymentMethodToUse = walletPM;
              }
            }

            if (!paymentMethodToUse?.name && !isStoreCredit) {
              message.warning("Select payment method");
              return;
            }

            if (isStoreCredit && !paymentMethodToUse?.name) {
              // No wallet payment method found — process order directly.
              // STORE_CREDIT orders send empty payments (handled in useOrderCompletion).
              await processOrder();
              // Clear STORE_CREDIT return type so it doesn't leak into the next transaction
              useTransactionStore.getState().setSelectedReturnType(null);
              setIsRefundWalletOpen(false);
              return;
            }

            await requestPayment(paymentMethodToUse, refundAmount.toFixed(2));
            // Clear STORE_CREDIT return type so it doesn't leak into the next transaction
            if (isStoreCredit) {
              useTransactionStore.getState().setSelectedReturnType(null);
            }
            setIsRefundWalletOpen(false);
            } finally {
              submittingRef.current = false;
              setSubmitting(false);
            }
          }}
        >
          Confirm Refund
        </Button>
      </div>
    </Drawer>
  );
};

export default RefundWalletDrawer;
